import {Space} from 'antd'
import styles from './UsersListPanel.module.scss'
import {Sort, Button, Search, SortIcon} from 'common/components'
import {maybePluralize} from 'common/helpers'

interface UsersListPanelProps {
  // isBroker?: boolean
  count: number
  search: string
  sort: string
  setSearch: (search: string) => void
  setSort: (sort: string) => void
}

const sortItems = [
  {label: 'Name', key: 'firstName'},
  {label: 'Date of registration', key: '-createdAt'},
]
export default function UsersListPanel({
  // isBroker = false,
  count,
  search,
  sort,
  setSearch,
  setSort,
}: UsersListPanelProps) {
  // const sortItems = isBroker ? brokersSortItems : borrowersSortItems

  const sortItem = sortItems.find((item) => item.key === sort)

  return (
    <div className={styles.root}>
      <Space>
        <h2 className={styles.title}>
          {maybePluralize(count, 'user' ) /*isBroker ? 'broker' : 'borrower')*/}
        </h2>
        <Search
          search={search}
          placeholder="name, email, phone number etc."
          setSearch={setSearch}
        />
      </Space>
      <Sort alignRightDropdown sort={sort} items={sortItems} setSort={setSort}>
        <Button dropdown variant="text">
          <Space>
            <SortIcon />
            <span>
              Sort by: <span className={styles.value}>{sortItem?.label || ''}</span>
            </span>
          </Space>
        </Button>
      </Sort>
    </div>
  )
}
